<template>
  <el-upload
    name="Filedata"
    :show-file-list="false"
    :action="FILESERVICE"
    :headers="upHeaders"
    :on-success="uploadSuccess"
    :before-upload="beforeUpload"
    :accept="accept"
  >
    <div v-loading="loading" class="content">
      <span v-if="value" class="file_name">{{ resourceName }}</span>
      <span v-else>点击上传</span>
      <span v-if="value" class="clear_span" @click.stop="clearFile">
        <i class="icon-guanbi iconfont"></i>
      </span>
      <i class="icon-shangchuananniu iconfont"></i>
    </div>
  </el-upload>
</template>

<script>

export default {
  name: "UploadMedia",
  props: {
    value: {
      type: String,
      default() {
        return "";
      }
    },
    accept: {
      type: String,
      default() {
        return "image/*,video/*,audio/*";
      }
    }
  },
  data() {
    return {
      upHeaders: {
        token: localStorage.getItem('user_ticket') || undefined
      },
      loading: false,
      resourceName: "",
      narrowImage: ""
    };
  },
  methods: {
    beforeUpload() {
      this.loading = true;
    },
    uploadSuccess(response) {
      this.loading = false;
      if (response.code === 0) {
        this.resourceName = response.resourceName;
        this.narrowImage = response.narrowImage;
        this.$emit("input", response.reourceAddress);
        this.$emit("success", response);
      } else {
        this.$message.error(response.message || response.msg);
      }
      this.$forceUpdate();
    },
    clearFile() {
      this.resourceName = "";
      this.narrowImage = "";
      this.$emit("input", "");
    }
  }
};
</script>

<style scoped lang="scss">
.content {
  width: 220px;
  text-align: left;
  padding-left: 15px;
  color: #999999;
  position: relative;
  .file_name {
    display: inline-block;
    color: #282729;
    width: 180px;
    overflow: hidden; //超出的文本隐藏
    text-overflow: ellipsis; //溢出用省略号显示
    white-space: nowrap; //溢出不
  }
  .icon-shangchuananniu {
    float: right;
    line-height: 28px;
  }
  .clear_span {
    position: absolute;
    top: 0px;
    right: 16px;
    cursor: pointer;
    display: none;
  }
  &:hover {
    .clear_span {
      display: block;
    }
  }
}
</style>
